<div class="bg-light w-100 text-end">
  <div class="row no-gutters pt-3">
    <div class="mx-3 col text-end">
      <button [routerLink]="this.entityroot + '/create-many'" type="button" class="btn btn-success">
        <i class="fas fa-file-csv"></i> Import from CSV
      </button>
    </div>
  </div>
</div>

<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [listEditPathCallback]="getListEditPathCallback()">
</app-crud-list>
